<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {

}
</script>

<style  lang="less" scoped>
* {
  box-sizing: border-box;
  font-family: Source Han Sans CN;
  margin: 0;
  padding: 0;
}
#app {
  background: #f2f2f2;
  width: 100%;
  max-width: 750px;
  margin: 0 auto !important;
  -moz-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  p {
    margin: 0;
  }
}
</style>
